document.addEventListener('click', function (e) {
  const openTrigger = e.target.closest('[data-bonsai-search="open"]');
  const closeTrigger = e.target.closest('[data-bonsai-search="close"]');
  const searchContainer = document.querySelector('.bonsai-search-outer-container');

  // OPEN (toggle)
  if (openTrigger) {
    e.preventDefault();
    document.body.classList.toggle('bonsai-search-enabled');
    return;
  }

  // CLOSE button / overlay
  if (closeTrigger) {
    e.preventDefault();
    document.body.classList.remove('bonsai-search-enabled');
    return;
  }

  // CLICK OUTSIDE → CLOSE
  if (
    document.body.classList.contains('bonsai-search-enabled') &&
    searchContainer &&
    !searchContainer.contains(e.target)
  ) {
    document.body.classList.remove('bonsai-search-enabled');
  }
});


// ESC key
document.addEventListener('keydown', function (e) {
  if (
    e.key === 'Escape' &&
    document.body.classList.contains('bonsai-search-enabled')
  ) {
    document.body.classList.remove('bonsai-search-enabled');
  }
});
